import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getMaintenanceTypeList,
	addNewMaintenanceType,
	updateMaintenanceType,
	deleteMaintenanceType,
	getMaintenanceType,
} from '../maintenanceType/thunk';

export const initialState = {
	itemMaintenanceTypeList: [],
	itemMaintenanceTypeDetail: null,
	isMaintenanceTypeLoading: false,
	isMaintenanceTypeSuccess: false,


	maintenanceTypeList: [],
	maintenanceTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const MaintenanceTypeSlice = createSlice({
	name: 'MaintenanceType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getMaintenanceType.fulfilled, (state, action) => {
			state.isMaintenanceTypeLoading = false;
			state.isMaintenanceTypeSuccess = true;
			state.itemMaintenanceTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getMaintenanceType.pending, state => {
			state.isMaintenanceTypeLoading = true;
			state.isMaintenanceTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getMaintenanceType.rejected, (state, action) => {
			state.isMaintenanceTypeLoading = false;
			state.isMaintenanceTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getMaintenanceTypeList.pending, state => {
			state.isMaintenanceTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getMaintenanceTypeList.fulfilled, (state, action) => {
			state.itemMaintenanceTypeList = action.payload;
			state.maintenanceTypeList = action.payload;
			state.isLoadingList = false;
			state.isMaintenanceTypeSuccess = true;

			let maintenanceTypeListSelect = [];
			action.payload.map(item =>
				maintenanceTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.maintenanceTypeListSelect = maintenanceTypeListSelect;
		});
		builder.addCase(getMaintenanceTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isMaintenanceTypeSuccess = true;
		});
		builder.addCase(addNewMaintenanceType.fulfilled, (state, action) => {
			state.itemMaintenanceTypeList.push(action.payload);
			state.maintenanceTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewMaintenanceType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewMaintenanceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateMaintenanceType.fulfilled, (state, action) => {
			state.itemMaintenanceTypeList = state.itemMaintenanceTypeList.map(maintenanceType =>
				maintenanceType.maintenanceTypename === action.payload.old_maintenanceType
					? { ...maintenanceType, ...action.payload.updated_maintenanceType }
					: maintenanceType
			);
			state.maintenanceTypeList = state.maintenanceTypeList.map(maintenanceType =>
				maintenanceType._id.toString() === action.payload._id.toString()
					? { ...maintenanceType, ...action.payload }
					: maintenanceType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateMaintenanceType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateMaintenanceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteMaintenanceType.fulfilled, (state, action) => {
			state.itemMaintenanceTypeList = current(state.itemMaintenanceTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.maintenanceTypeList = current(state.maintenanceTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteMaintenanceType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteMaintenanceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = MaintenanceTypeSlice.actions;

export default MaintenanceTypeSlice.reducer;
